<script setup>
import { onMounted, ref } from "vue";
import Menubar from 'primevue/menubar';
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import { useUserStore }  from '@/stores/user';
const route = useRoute(); // Obtener la ruta actual
const router = useRouter(); // Router para navegación
const userStore = useUserStore();

// Obtener el rol de usuario del store de Pinia (reactivo)
const userRole = computed(() => userStore?.user?.type || "manager");

// Este valor debe obtenerse de la autenticación

const items = ref([
    {
        label: 'Contactos',
        icon: 'pi pi-address-book',
        name: 'CorporateAgenda' // Nombre de la ruta

    },
    {
        label: 'Usuarios',
        icon: 'pi pi-users',
        name: 'Users'

    },
    {
        label: 'Empresas',
        icon: 'pi pi-shop',
        name: 'Companies'

    },
    {
        label: 'Centros',
        icon: 'pi pi-thumbtack',
        name: 'Centers'

    },
    {
        label: 'Departamentos',
        icon: 'pi pi-tag',
        name: 'Departments'

    }
]);



// Función para determinar si un elemento está activo
const isActive = (name) => {
    return route.name === name; // Compara el nombre de la ruta actual con el nombre del elemento
};

// Función para manejar la navegación
const navigateTo = (name) => {
    router.push({ name }); // Navega a la ruta especificada por su nombre
};


// Filtro dinámico basado en el rol del usuario
const filteredItems = computed(() => {
  if (userRole.value === "admin") {
    return items.value; // Mostrar todos los elementos si es admin
  }
  if (userRole.value === "manager") {
    return items.value.filter(
      (item) =>
        ["CorporateAgenda", "Centers", "Departments"].includes(item.name) // Mostrar solo estos
    );
  }
  if (userRole.value === "observer") {
    return items.value.filter((item) => item.name === "CorporateAgenda"); // Mostrar solo "CorporateAgenda"
  }
  return []; // Si no es un rol válido, no mostrar nada
});




</script>
<template>
    <div class="menu-dashboard" v-animate-css="'fadeIn'">

        <Menubar>
            <template #start>
                <ul class="p-menubar-root-list">
                    <li 
                        v-for="item in filteredItems" 
                        :key="item.label" 
                        @click="navigateTo(item.name)" 
                        :class="{ 'active-menu': isActive(item.name) }"
                    >
                        <i :class="item.icon"></i>
                        <span>{{ item.label }}</span>
                    </li>
                    </ul>
            </template>
        </Menubar>
    </div>
</template>


<style lang="scss">
.menu-dashboard {
    .p-menubar-root-list {

        span {
            font-size: 13px;
            font-weight: 700;
        }

        li {
            display: flex;
            align-items: center;
            padding: 0.35rem 0.75rem !important;
            cursor: pointer;
            border-radius: 4px;
            transition: background 0.3s ease;

            &.active-menu {
                background: #f1f5f9; /* Color que ya tienes en hover */
            }

            &:hover {
                background: #f1f5f9; /* Mantén el estilo de hover como activo */
            }

            i {
                margin-right: 0.5rem;
            }
        }
    }
}
</style>


<style lang="scss">
.menu-dashboard {
    .p-menubar {
    display: flex;
    align-items: center;
    background: var(--p-menubar-background);
    border: 0px !important;
    border-radius: var(--p-menubar-border-radius);
    color: var(--p-menubar-color);
    padding: var(--p-menubar-padding);
    gap: var(--p-menubar-gap);
    padding-left: 0 !important;
}

}
   
</style>